export const data = [
    {
        key: 'QD',
        value: '渠道',
    },
    {
        key: 'YZ',
        value: '业主',
    },
    {
        key: 'DL',
        value: '代理',
    },
];

export function getValueByKey(key) {
    for (let i = 0; i < data.length; i++) {
        if (data[i].key === key) {
            return data[i].value;
        }
    }

    return '';
}
